// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"CategoriesModal_modalHeader__pLRwY","closeModal":"CategoriesModal_closeModal__aGrCr"};